export default __webpack_public_path__ + "static/media/Gifsite2-1.d1bcad22.m4v";